export interface SnackbarPayload {
  variant?: InfoBlockVariant;
  action?: () => void;
  actionBtnText?: string;
}

export type InfoBlockVariant = 'info' | 'success' | 'error';
